import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, ButtonVariant } from "@withfriendsco/wf-components";
const HomeButton = ({ refetchBusiness }) => {
    const navigate = useNavigate();
    return (_jsx(Button, { className: "my-4 home-button hidden", variant: ButtonVariant.Outlined, onClick: () => {
            refetchBusiness && refetchBusiness();
            setTimeout(() => { navigate("/"); }, 1000);
        }, children: "Refresh Me" }));
};
export default HomeButton;
